/**
 * Repository-resolved assets.
 *
 * The application is the only layer allowed to know where things live. Identity masters are
 * referenced by URL so their geometry reaches the DOM untouched. The redesign removed every media
 * dependency from the first paint: the hero is typographic, so no poster or film resolves here.
 */

import lockupHorizontalUrl from '../../../../identity/lockups/masters/civili-lockup-horizontal-master.svg?url';
import mark000Url from '../../../../identity/monolith/mark-000/mark-000-master.svg?url';

export const identityAssets = Object.freeze({
  lockupHorizontal: lockupHorizontalUrl,
  mark000: mark000Url
});
